// 统一请求路径前缀在libs/axios.js中修改
import { getRequest, postRequest, putRequest, postBodyRequest, getNoAuthRequest, postNoAuthRequest } from '@/libs/axios';

// 分页获取数据
export const getAppUserDeviceList = (params) => {
    return postRequest('/busi/appUserDevice/getByCondition', params)
}
// 添加
export const addAppUserDevice = (params) => {
    return postRequest('/busi/appUserDevice/insert', params)
}
// 编辑
export const editAppUserDevice = (params) => {
    return postRequest('/busi/appUserDevice/update', params)
}
// 删除
export const deleteAppUserDevice = (params) => {
    return postRequest('/busi/appUserDevice/delByIds', params)
}